module.exports = __webpack_public_path__ + "static/img/3.edb4409.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/3.png
// module id = 6Q1r
// module chunks = 0